import React, { useEffect, useMemo, useState } from "react";
import {
  CircularProgress,
  Grid,
  Box,
  Button,
  TextField,
  Card,
  Typography,
  Autocomplete,
} from "@mui/material";
import {
  useCreateNewsletterEmailWorkshopsMutation,
  useGetEmailTemplatesQuery,
} from "../../../Api/attoDeskApi";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import { useNotifier } from "../../../Core/Notifier";
import CloseIcon from "@mui/icons-material/Close";
import { useFormik } from "formik";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import AddIcon from "@mui/icons-material/Add";
import { uploadAttachments } from "../../../Components/UploadFile/upload";
import { widthofReactQuill } from "../../../Core/Enum/enum";
import { useLocation } from "react-router-dom";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import {
  EmailTemplateOption,
  IEmailTemplet,
} from "../../../Api/Interface/api.interface";
import { toProperCase } from "../../../Components/Validation/toProperCase";
import SendIcon from "@mui/icons-material/Send";

interface FormValues {
  subject: string;
  message: string;
  workshopMemberIds: number[];
  attachments: File[];
}

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { showErrorMessage, showMessage } = useNotifier();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const ids = query.get("ids")?.split(",").map(Number) ?? [];
  const [attachments, setAttachments] = useState<File[]>([]);
  const [selectedOption, setSelectedOption] =
    useState<EmailTemplateOption | null>(null);

  const [newEmail, { isLoading: createEmaliRecordLoading }] =
    useCreateNewsletterEmailWorkshopsMutation();

  const { data: userroleData, isLoading: userroleIsLoading } =
    useGetEmailTemplatesQuery({
      searchText: "",
    });

  const userroleList = useMemo(() => {
    return userroleData?.data as IEmailTemplet[];
  }, [userroleData?.data]);

  const userRoleOptions: EmailTemplateOption[] = useMemo(() => {
    if (!Array.isArray(userroleList)) return [];
    return userroleList.map((cust) => ({
      label: toProperCase(cust.template_name),
      value: cust.id,
      subject: cust.subject,
      message: cust.message,
      attachments: cust.attachments,
    }));
  }, [userroleList]);

  const formikEmail = useFormik<FormValues>({
    initialValues: {
      workshopMemberIds: ids,
      subject: "",
      message: "",
      attachments: [],
    },
    enableReinitialize: true,
    onSubmit: async (values, { resetForm }) => {
      try {
        const uploadedUrls: string[] = [];

        for (const file of attachments) {
          try {
            const url = await uploadAttachments(file);
            if (url) {
              uploadedUrls.push(url);
            }
          } catch (error) {
            showMessage(`Failed to upload file ${file.name}: ${error}`);
          }
        }

        console.log("Uploaded URLs:", uploadedUrls);

        const payload = {
          workshopMemberIds: values.workshopMemberIds,
          subject: values.subject,
          message: values.message,
          attachments: uploadedUrls,
        };

        const addCompanyResponse = await newEmail(payload).unwrap();

        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          showMessage(addCompanyResponse.message);
          navigate(
            `/workshop/newsletter/e-mail/view/${addCompanyResponse.data.id}`
          );
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  const handleResetSetValueFormik = () => {
    formikEmail.setFieldValue("subject", "");
    formikEmail.setFieldValue("message", "");
  };

  const formValidEmail = useMemo(() => {
    return (
      formikEmail.values.subject &&
      formikEmail.values.message &&
      formikEmail.values.workshopMemberIds.length > 0
    );
  }, [formikEmail]);

  const handleAutocompleteChange = (
    event: React.SyntheticEvent,
    newValue: EmailTemplateOption | null
  ) => {
    setSelectedOption(newValue);

    if (newValue) {
      // formikEmail.setValues({
      //   workshopMemberIds: ids,
      //   subject: newValue.subject || "",
      //   message: newValue.message || "",
      //   attachments: [],
      // });
      formikEmail.setFieldValue("subject", newValue.subject || "");
      formikEmail.setFieldValue("message", newValue.message || "");
    } else {
      // formikEmail.resetForm();
      formikEmail.setFieldValue("subject", "");
      formikEmail.setFieldValue("message", "");
    }
  };
  return (
    <div>
      <Grid container spacing={3}>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <form onSubmit={formikEmail.handleSubmit}>
            <Grid container>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.card}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={8}
                      md={6}
                      sm={12}
                      xs={12}
                      pt={2}
                      alignContent={"center"}
                    >
                      <Typography className={classes.cardTitle}>
                        E-mail
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      lg={4}
                      md={6}
                      sm={12}
                      xs={12}
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Autocomplete
                        options={userRoleOptions}
                        loading={userroleIsLoading}
                        // value={
                        //   userRoleOptions.find(
                        //     (option) =>
                        //       String(option.value) ===
                        //       selectedpolicyProductId
                        //   ) || null
                        // }
                        // getOptionLabel={(option: CustomerOptionString) =>
                        //   option.label
                        // }
                        // onChange={(
                        //   event,
                        //   newValue: CustomerOptionString | null
                        // ) => {
                        //   setSelectedIC(String(newValue?.value ?? ""));
                        // }}

                        value={selectedOption}
                        getOptionLabel={(option) => option.label}
                        onChange={handleAutocompleteChange}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            InputLabelProps={{ shrink: true }}
                            placeholder="Template Name  .."
                          />
                        )}
                        sx={{ flexGrow: 1, width: "100%" }}
                        size="small"
                        // className={classes.searchTextField}
                      />
                    </Grid>
                  </Grid>

                  <Grid container spacing={3} p={"24px"}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            Subject{" "}
                            <span className={classes.requiedfield}>*</span>
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            placeholder="Subject"
                            size="small"
                            multiline
                            rows={3}
                            {...formikEmail.getFieldProps("subject")}
                            className={classes.textField}
                            InputProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12} pb={5}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            Message{" "}
                            <span className={classes.requiedfield}>*</span>
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <ReactQuill
                            value={formikEmail.values.message}
                            onChange={(value) =>
                              formikEmail.setFieldValue("message", value)
                            }
                            placeholder="Type your message..."
                            theme="snow"
                            style={{ height: widthofReactQuill["400px"] }}
                            modules={{
                              toolbar: [
                                [{ font: [] }],
                                [{ header: [1, 2, 3, 4, 5, 6, false] }],
                                ["bold", "italic", "underline", "strike"],
                                [{ color: [] }, { background: [] }],
                                [{ script: "sub" }, { script: "super" }],
                                [{ list: "ordered" }, { list: "bullet" }],
                                [{ indent: "-1" }, { indent: "+1" }],
                                [{ direction: "rtl" }],
                                [{ align: [] }],
                                ["blockquote", "code-block"],
                                ["link", "image", "video"],
                                ["clean"],
                              ],
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Typography variant="subtitle1">Attachments</Typography>
                      <input
                        type="file"
                        multiple
                        accept="image/*,video/*,application/pdf"
                        onChange={(e) => {
                          if (e.target.files) {
                            setAttachments(Array.from(e.target.files));
                          }
                        }}
                        style={{ marginTop: "8px" }}
                      />
                      {attachments.length > 0 && (
                        <Box mt={1}>
                          {attachments.map((file, index) => (
                            <Typography key={index} variant="body2">
                              {file.name}
                            </Typography>
                          ))}
                        </Box>
                      )}
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12} pt={5}>
                      <Grid
                        container
                        spacing={2}
                        justifyContent={"space-between"}
                      >
                        <Grid
                          item
                          lg={4}
                          md={6}
                          sm={12}
                          xs={12}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        ></Grid>
                        <Grid
                          item
                          lg={8}
                          md={6}
                          sm={12}
                          xs={12}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <Button
                            variant="outlined"
                            startIcon={<CloseIcon />}
                            className={classes.addButton}
                            onClick={() => handleResetSetValueFormik()}
                          >
                            Reset
                          </Button>
                          <Box m={0.5}></Box>

                          <Button
                            variant="contained"
                            startIcon={
                              createEmaliRecordLoading ? (
                                <CircularProgress
                                  size={18}
                                  className={classes.isLoading}
                                />
                              ) : (
                                <SendIcon />
                              )
                            }
                            className={classes.addButton}
                            onClick={() => formikEmail.handleSubmit()}
                            disabled={
                              !formValidEmail || createEmaliRecordLoading
                            }
                          >
                            Send
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Grid>
    </div>
  );
};

export default Index;
